import { createDOMRenderer } from "@fluentui/react-components";

/**
 * Der Griffel-Renderer des Hauptfensters (Styles von `makeStyles`).
 *
 * App.tsx reicht ihn per `RendererProvider` durch; ein Fensterinhalt bekommt
 * ihn im Hauptfenster ebenfalls, im ausgelagerten Browserfenster einen eigenen
 * (`rendererFuer`). Wechselt nur der Wert, bleibt der Inhalt gemountet.
 */
let haupt: ReturnType<typeof createDOMRenderer> | null = null;

/** Erst beim ersten Gebrauch angelegt — Tests, die Fluent wegmocken, laden das Modul trotzdem. */
export function hauptRenderer() {
  haupt ??= createDOMRenderer(typeof document === "undefined" ? undefined : document);
  return haupt;
}

const jeDokument = new WeakMap<Document, ReturnType<typeof createDOMRenderer>>();

export function rendererFuer(dok: Document) {
  if (dok === document) return hauptRenderer();
  let r = jeDokument.get(dok);
  if (!r) {
    r = createDOMRenderer(dok);
    jeDokument.set(dok, r);
  }
  return r;
}
